import React, { useState } from "react";
import PropTypes from "prop-types";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import "../css/GalleryComponent.css";

/**
 * Reusable Gallery Component
 * @param {Array} images - danh sách ảnh [{ original: string, thumbnail: string }]
 * @param {boolean} showPlayButton - có hiển thị nút play (autoplay) không
 * @param {boolean} showFullscreenButton - có hiển thị fullscreen button không
 */
const GalleryComponent = ({ 
  images, 
  showPlayButton = false, 
  showFullscreenButton = true 
}) => {
    const [isFullscreen, setIsFullscreen] = useState(false);
  return (
    <div className={`gallery-wrapper ${isFullscreen ? "fullscreen" : ""}`}>
      <ImageGallery
        items={images}
        showPlayButton={showPlayButton}
        showFullscreenButton={showFullscreenButton}
        showThumbnails={true}
        slideOnThumbnailOver={true}
        thumbnailPosition="bottom"
        onScreenChange={(isFull) => setIsFullscreen(isFull)}
      />
    </div>
  );
};

GalleryComponent.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      original: PropTypes.string.isRequired,
      thumbnail: PropTypes.string.isRequired,
    })
  ).isRequired,
  showPlayButton: PropTypes.bool,
  showFullscreenButton: PropTypes.bool,
};

export default GalleryComponent;
